/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Password_LabelInputs */

const en_login_password_label = /** @type {(inputs: Login_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const fr_login_password_label = /** @type {(inputs: Login_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de Passe`)
};

const de_login_password_label = /** @type {(inputs: Login_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort`)
};

const it_login_password_label = /** @type {(inputs: Login_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const ru_login_password_label = /** @type {(inputs: Login_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пароль`)
};

const es_login_password_label = /** @type {(inputs: Login_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña`)
};

const zh_cn2_login_password_label = /** @type {(inputs: Login_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码`)
};

const ja_login_password_label = /** @type {(inputs: Login_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワード`)
};

const hi_login_password_label = /** @type {(inputs: Login_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पासवर्ड`)
};

const pt_pt2_login_password_label = /** @type {(inputs: Login_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senha`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {Login_Password_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_password_label = /** @type {((inputs?: Login_Password_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Password_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_password_label(inputs)
	if (locale === "de") return de_login_password_label(inputs)
	if (locale === "it") return it_login_password_label(inputs)
	if (locale === "ru") return ru_login_password_label(inputs)
	if (locale === "es") return es_login_password_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_password_label(inputs)
	if (locale === "ja") return ja_login_password_label(inputs)
	if (locale === "hi") return hi_login_password_label(inputs)
	if (locale === "pt-PT") return pt_pt2_login_password_label(inputs)
	return en_login_password_label(inputs)
});